import preact from "preact/compat"
export * from "preact/compat"
export const use = false
export default preact